import React from 'react';
import CheckboxField from 'components/pure/utils/form/CheckboxField';
import MailActions from 'actions/inbox/MailActions';
import InboxItemActionButtons from './inbox-item-action-buttons/InboxItemActionButtons';
import RemoveIcon from 'material-ui/svg-icons/content/remove-circle';
import './MailToolbar.styl';

export default class ActionToolbar extends React.PureComponent {
  render() {
    return (
      <div className="mail-toolbar">
        <CheckboxField
          className="unselect-all"
          title="Unselect all"
          checked={true}
          checkedIcon={<RemoveIcon />}
          onCheck={MailActions.unselectAll}
        />
        <InboxItemActionButtons
          targets={this.props.targets}
          areAllSelected={this.props.areAllSelected}
          filters={this.props.filters}
          onActionCompleted={() => {
            this.props.onActionCompleted();
            MailActions.unselectAll();
          }}
          folders={this.props.folders}
          showMoveToTrash={this.props.showMoveToTrash}
          showMarkAsRead
          showPin
          showMoveToFolder
        />
      </div>
    );
  }
}
